import React from "react";
import cn from "classnames";
// import { Link } from "react-router-dom";
import styles from "./Main.module.sass";
import pageStyles from "../../InfoPage/InfoPage.module.sass";
import PostcardHero from "../../../components/PostcardHero";
import useTrustedCarouselProfiles from "../../../hooks/useTrustedCarouselProfiles";
import IntroVideoPreview from "../../../components/IntroVideoPreview";

const Main = ({ homeLayout, email, setEmail, onSubmit, submitting, ok }) => {
  const trustedProfiles = useTrustedCarouselProfiles();
  const profileCount = Math.max(trustedProfiles.length, 1);
  // Scale animation horizon with item count so perceived speed stays consistent.
  const desktopDurationSeconds = Math.min(520, Math.max(52, Math.round(profileCount * 3.8)));
  const mobileDurationSeconds = Math.min(620, Math.max(68, Math.round(profileCount * 4.6)));
  const carouselTimingVars = {
    "--home-carousel-duration-desktop": `${desktopDurationSeconds}s`,
    "--home-carousel-duration-mobile": `${mobileDurationSeconds}s`,
  };
  const homeCarouselAddon = homeLayout ? (
    <div className={styles.homeTrustedCarousel} aria-label="Trusted hosts and creators">
      <div className={styles.homeTrustedCarouselTitle}>
        Trusted by top travel creators, photographers and hosts in the hospitality industry.
      </div>
      <div className={styles.homeTrustedCarouselViewport}>
        <div className={styles.homeTrustedCarouselTrack} style={carouselTimingVars}>
          {[...trustedProfiles, ...trustedProfiles].map((profile, idx) => (
            <div className={styles.homeTrustedCarouselItem} key={`${profile.handle}-${idx}`}>
              {profile.introVideoUrl ? (
                <IntroVideoPreview
                  className={styles.homeTrustedCarouselAvatar}
                  mode="card"
                  posterUrl={profile.introVideoPosterUrl || profile.image}
                  publicId={profile.introVideoPublicId}
                  fullUrl={profile.introVideoUrl}
                  fallbackImageUrl={profile.image}
                  alt={profile.handle}
                />
              ) : (
                <img
                  src={profile.image}
                  alt={profile.handle}
                  className={styles.homeTrustedCarouselAvatar}
                  loading="lazy"
                />
              )}
              <span className={styles.homeTrustedCarouselHandle}>{profile.handle}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  ) : null;
  
  return (
    <div className={cn("section", styles.section, { [styles.homeLayout]: homeLayout })}>
      <div className={cn("container", styles.container)}>
        <div className={cn(styles.preview, pageStyles.previewAuto)}>
          <div className={cn(styles.wrap, pageStyles.innerWrap)}>
            <PostcardHero
              homeLayout={homeLayout}
              tall={!homeLayout}
              email={email}
              setEmail={setEmail}
              onSubmit={onSubmit}
              submitting={submitting}
              ok={ok}
              customMinHeight={homeLayout ? 450 : undefined}
              brandHeaderAddon={homeCarouselAddon}
            />
            <h1 className={cn("hero", styles.title)} style={{ display: "none" }}>Search, stay, share</h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Main;
